import {
  call, delay, put, takeLatest,
} from 'redux-saga/effects';
import api from '@/api/b2b-companies';
import {
  VALIDATION_ERROR_REQUEST,
} from '@/action-types/error';
import {
  LOADING_UPDATE_REQUEST,
} from '@/action-types/loading';
import {
  REGISTRATION_COMPANY_REQUEST,
  REGISTRATION_COMPANY_SUCCESS,
  GET_COMPANIES_REQUEST, GET_COMPANIES_SUCCESS,
} from '@/action-types/b2b-companies';

import { Action } from 'redux';
import { IB2bCompany } from '@/interfaces/base/interfaces';
import { decodeInviteLink } from '@/utils/deencode-invite-link';
import { CHANGE_PAGE } from '@/action-types/app';
import { LOGIN_AUTH_UPDATE_ACCESS } from '@/action-types/login';

export function* addB2BCompany(params: Action & { companyData: IB2bCompany;}) {
  try {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'b2bCompanies', state: true });

    yield call(api.addB2BCompany, {
      email: params.companyData.email,
      contactPerson: params.companyData.contactPerson,
      phone: params.companyData.phone,
      title: params.companyData.title,
    });

    yield put({ type: REGISTRATION_COMPANY_SUCCESS });
  } catch (e) {
    yield put({ type: VALIDATION_ERROR_REQUEST, isActive: true, errorData: e });
  } finally {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'b2bCompanies', state: false });
  }
}

export function* getB2BCompanies() {
  try {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'b2bCompanies', state: true });

    const companiesArr = yield call(api.getB2BCompanies);

    if (companiesArr?.data.getB2BCompanies?.length) {
      yield put({ type: GET_COMPANIES_SUCCESS, companies: companiesArr?.data.getB2BCompanies });
    }
  } finally {
    yield put({ type: LOADING_UPDATE_REQUEST, name: 'b2bCompanies', state: false });
  }
}

export function* inviteB2BToCompany(params: Action & {
  state: {
    from: {
      pathname: string;
    };
  };
}) {
  try {
    const hashData = yield call(decodeInviteLink, params?.state?.from?.pathname);

    if (hashData?.b2bCompanyId) {
      yield call(api.inviteB2BToCompany, hashData.b2bCompanyId);

      yield delay(5000);
      yield put({ type: LOGIN_AUTH_UPDATE_ACCESS });
    }
  } catch (e) {
    console.log(e);
  }
}

export default function* b2bCompanies() {
  yield takeLatest(REGISTRATION_COMPANY_REQUEST, addB2BCompany);
  yield takeLatest(GET_COMPANIES_REQUEST, getB2BCompanies);
  yield takeLatest(CHANGE_PAGE, inviteB2BToCompany);
}
